import React from "react";
import { Route, Routes } from "react-router-dom";
import FeePage from "./Fee";

export default function ManagePage() {
    return (
      <Routes>
        <Route
          path="/fee"
          element={<FeePage />}
        />
      </Routes>
    );
  }